import { FunctionComponent, useEffect } from "react";
import UnAuthenticated from "../UnAuthenticated";
import GalleryPhotos from "./GalleryPhotos";
import GallerySingle from "./GallerySingle";
import GridGallery from "./GridGallery";
import GalleryFullscreen from "./GalleryFullscreen";

export interface IIndex {
  configsFromLayout: any;
}

const Index: FunctionComponent<IIndex> = ({ configsFromLayout }) => {
  const layout = configsFromLayout?.configs?.layout?.value;
  const instanceId =
    configsFromLayout?.instanceId || configsFromLayout?.id || "";

  useEffect(() => {
    document.title = instanceId ? `gallery.${instanceId}` : "Gallery";

    return () => {
      document.title = "Gallery";
    };
  }, [instanceId]);

  if (!configsFromLayout)
    return <UnAuthenticated text="Please login to get started!" />;

  function LayoutCases() {
    switch (layout) {
      case "gallery":
        return <GalleryPhotos configsFromLayout={configsFromLayout} />;
      case "grid":
        return <GridGallery configsFromLayout={configsFromLayout} />;
      case "single":
        return <GallerySingle configsFromLayout={configsFromLayout} />;
      case "fullscreen":
        return <GalleryFullscreen configsFromLayout={configsFromLayout} />;
      default:
        break;
    }
  }
  return (
    <div
      className="h-screen pointer-events-none"
      style={{ background: configsFromLayout?.configs?.background?.value }}
    >
      {LayoutCases()}
    </div>
  );
};

export default Index;
